import { Box } from "@mui/material";
import React from "react";
import ModalHeaderWithSalesInvoiceRejectionAfterCustomerPurchase from "../../../components/modals/ModalHeaderWithSalesInvoiceRejectionAfterCustomerPurchase";

export default function HeaderWithSalesInvoiceRejectionAfterCustomerPurchase({
  saleInfo,
  saleKey,
}: any) {
  return (
    <div>
      <Box
        sx={{
          marginRight: "1.9vh",
          marginLeft: "1.9vh",
          direction: "rtl",
          overflowX: "none",
          textAlign: "end",
        }}
      >
        <ModalHeaderWithSalesInvoiceRejectionAfterCustomerPurchase
          saleKey={saleKey}
          amount={saleInfo.saleDetail.saleAmount}
          customer={saleInfo.header.customerInformation.customerFullName}
          aggregatedSaleWalletDetail={
            saleInfo.saleDetail.aggregatedSaleWalletDetail
          }
          cash={saleInfo.saleDetail.cashAmount}
          pay={
            saleInfo.saleDetail.paymentDetail?.onlinePaymentInformation
              ? saleInfo.saleDetail.paymentDetail?.onlinePaymentInformation
                  .gatewayTitle
              : ""
          }
        />
      </Box>
    </div>
  );
}
